<template>
    <div>
        <div v-if="visibleRatingMerchantStep === 1" class="rating-merchant">
            <p class="title">{{$t('SHARE_ORDER.rating_merchant.title', {merchant_name : order.partner})}}</p>
            <div class="options">
                <div class="option" @click="onSelectOption(option)" :class="{'active' : isActiveOption(option)}" v-for="option in rateMerchantOptions" :key="option.value">
                    <img :src="option.icon" alt="">
                    <p>{{option.text}}</p>
                </div>
            </div>
        </div>
        <div v-if="visibleRatingMerchantStep === 2" class="rating-merchant__detail">
            <div class="rating-merchant__detail-header">
                <p class="title-header">{{selectedOption && selectedOption[0] && selectedOption[0].text}}</p>
                <div class="option" @click="onSelectOption(option)" :class="{'active' : isActiveOption(option)}" v-for="option in rateMerchantOptions" :key="option.value">
                    <img :src="option.icon" alt="">
                </div>
            </div>
            <div class="rating-merchant__detail-body">
                <h3>{{isLikeOption ? $t('SHARE_ORDER.rating_merchant.reason_title.like') : $t('SHARE_ORDER.rating_merchant.reason_title.dislike') }}</h3>
                <div class="reasons">
                    <div class="reason" 
                        @click="onSelectReason(reason)" 
                        :class="{'active' : isActiveReason(reason)}" 
                        v-for="(reason, index) in isLikeOption ? badgeListPositive : badgeListNegative" 
                        :key="index">
                            {{reason.text}}
                    </div>
                </div>
                <div class="leave-feedback" @click="handleLeaveFeedback" v-if="!visibleTextarea">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7Z" fill="#FF8200"/>
                    </svg>
                    <span>{{ $t(`SHARE_ORDER.rating_driver.leave_feedback`)}}</span>
                </div>
                <div class="feedback-rating" v-else>
                    <textarea v-model="comment" @input="handleChangeTextArea" :placeholder="$t(`SHARE_ORDER.rating_driver.placeholder_textarea`)" rows="5"></textarea>
                    <p>{{$t(`SHARE_ORDER.rating_driver.limit_characters`, {numbers : 6})}}</p>
                </div>
                <div class="submit">
                    <button class="btn-submit"
                        :class="{'active' : visibleSubmit}" 
                        @click="visibleSubmit ? handleSubmit() : ''">
                        {{ $t(`SHARE_ORDER.rating_driver.submit`)}}
                    </button>
                </div>
            </div>
        </div>
        <div v-if="visibleRatingMerchantStep === 3" class="rating-merchant__success">
            <img :src="selectedOption && selectedOption[0].icon"  width="100" height="100" alt="">
            <p> {{dataRatedText}}</p>
            
            <div class="close">
                <button class="btn-close"
                    @click="handleClose()">
                    {{ $t(`SHARE_ORDER.rating_driver.close`)}}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
// export const findIndex = require("lodash/findIndex")

export default {
    props : {
        order: Object
    },
    data() {
        return {
            visibleRatingMerchantStep: 1,
            visibleTextarea : false,
            visibleSubmit : false,
            comment : '',
            selectedOption : [],
            selectedReasons : [],
            badgeListPositive : [
                {
                    text : this.$t('SHARE_ORDER.rating_merchant.reason_detail.like.delicous'),
                    key : 'Delicious'
                },
                {
                    text : this.$t('SHARE_ORDER.rating_merchant.reason_detail.like.good_price'),
                    key : 'good_price'
                },
                {
                    text : this.$t('SHARE_ORDER.rating_merchant.reason_detail.like.good_package'),
                    key : 'Good package'
                },
                {
                    text: this.$t('SHARE_ORDER.rating_merchant.reason_detail.like.correct_order'),
                    key: 'Correct order'
                },
                {
                    text : this.$t('SHARE_ORDER.rating_merchant.reason_detail.like.plentiful_menu'),
                    key : 'Plentiful menu'
                },
                {
                    text : this.$t('SHARE_ORDER.rating_merchant.reason_detail.like.other'),
                    key : 'Other'
                }
                // 'Delicious','Fresh & clean','Price','Nice package','Menu variety'
            ],
            badgeListNegative : [
                 {
                    text : this.$t('SHARE_ORDER.rating_merchant.reason_detail.dislike.not_delicious'),
                    key : 'Not delicious'
                },
                {
                    text : this.$t('SHARE_ORDER.rating_merchant.reason_detail.dislike.high_price'),
                    key : 'High price'
                },
                {
                    text : this.$t('SHARE_ORDER.rating_merchant.reason_detail.dislike.unsanitary'),
                    key : 'Unsanitary'
                },
                {
                    text: this.$t('SHARE_ORDER.rating_merchant.reason_detail.dislike.bad_package'),
                    key: 'Bad package'
                },
                {
                    text : this.$t('SHARE_ORDER.rating_merchant.reason_detail.dislike.wrong_lack_of_goods'),
                    key : 'Wrong / Lack of goods'
                },
                // 'Not delicious','Not fresh', 'Expensive','Bad packaging','Poor menu'
            ],
            rateMerchantOptions : [
                {
                    key: 'LIKE',
                    icon : '/img/icons/Like.svg',
                    text : this.$t('SHARE_ORDER.rating_merchant.options.like')
                },
                {
                    key: 'DISLIKE',
                    icon : '/img/icons/dislike.svg',
                    text : this.$t('SHARE_ORDER.rating_merchant.options.dislike')
                }
            ],
            rateMerchantFormData : {},
            dataRatedText : ''
        }
    },
    computed : {
        isLikeOption() {
            return this.selectedOption && this.selectedOption[0] && this.selectedOption[0].key === 'LIKE'
        }
    },
    methods : {
        onSelectOption(option){
            this.visibleTextarea = false
            this.comment = ''
            this.selectedReasons.length = 0
            
            const optionIndex = this.selectedOption && this.selectedOption.findIndex(o => { return o.key === option.key })
            // findIndex(this.selectedOption, { key: option.key });
            if (optionIndex > -1) {
                return
            } else {
                this.selectedOption.length = 0
                this.selectedOption.push(option);
            }
            if(this.visibleRatingMerchantStep === 1) {
                this.visibleRatingMerchantStep++
            }

            if(this.selectedOption[0].key === 'LIKE') {
                this.visibleSubmit = true
            }else{ 
                this.visibleSubmit = false
            }
        },
        onSelectReason(reason) {
            const optionIndex = this.selectedReasons && this.selectedReasons.findIndex(s => { return s.key === reason.key })
            // findIndex(this.selectedReasons, { key: reason.key });

            optionIndex > -1
            ? this.selectedReasons.splice(optionIndex, 1)
            : this.selectedReasons.push(reason);

            if(this.selectedOption[0].key === 'DISLIKE'){
                if(this.selectedReasons && this.selectedReasons.length > 0){
                    if(!this.comment || this.comment.length == 0) {
                        this.visibleSubmit = true
                    }else {
                        if(this.comment.length >= 6) {
                            this.visibleSubmit = true
                        }else{
                            this.visibleSubmit = false
                        }
                    }
                } else {
                    if(this.comment.length >= 6) {
                        this.visibleSubmit = true
                    }else{
                        this.visibleSubmit = false
                    }
                }
            }
        },
        isActiveOption(option) {
            const optionIndex = this.selectedOption && this.selectedOption.findIndex(s => { return s.key === option.key })
            // findIndex(this.selectedOption, { key: option.key });
            return optionIndex > -1 ? true : false;
        },
        isActiveReason(reason) {
            const optionIndex = this.selectedReasons && this.selectedReasons.findIndex(s => { return s.key === reason.key })
            // findIndex(this.selectedReasons, { key: reason.key });
            return optionIndex > -1 ? true : false;
        },

        handleLeaveFeedback() {
            this.visibleTextarea = true
        },
        handleChangeTextArea($event){
            this.comment = $event.target.value

            if(this.selectedOption[0].key === 'DISLIKE') {
                if(this.selectedReasons.length > 0) {
                    if(this.comment.length >= 6) {
                        this.visibleSubmit = true
                    } else {
                        this.visibleSubmit = false
                    }
                } else if (this.selectedReasons.length === 0) {
                    if(this.comment.length >= 6) {
                        this.visibleSubmit = true
                    } else {
                        this.visibleSubmit = false
                    }
                }
            } else {
                if(this.comment.length >= 6 || this.comment.length === 0) {
                    this.visibleSubmit = true
                } else {
                    this.visibleSubmit = false
                }
            }
        },
        handleSubmit() {

            let comments = this.selectedReasons.map(reason => {
                return reason.key;
            });


            this.rateMerchantFormData  = { 
                order_id : this.order._id,
                rate : this.selectedOption[0].key === 'LIKE' ? true : false, 
                comment : comments.join(",").toUpperCase() + " " +  this.comment.trim()
            }

            this.selectedOption[0].key === 'LIKE'
              ?  this.dataRatedText = this.$t('SHARE_ORDER.rating_merchant.message.like')
              :  this.dataRatedText = this.$t('SHARE_ORDER.rating_merchant.message.dislike')

            this.visibleRatingMerchantStep++

            this.$store.dispatch('ratingPartner', this.rateMerchantFormData).catch(err => {
                console.log("ratingPartner err", err)
            })

        },

        handleClose() {
            this.$emit('onClose')
        }
    }
}
</script>
<style lang="scss" scoped>
.option{
    margin: 0 20px;
    cursor: pointer;
    img{
        border-radius: 50%;
        background-color: #EEF3F9;
    }
    p{
        color: #7A8189;
        font-size: 14px;
        font-weight: 500;
    }
}

.option.active {
    img{
        background-color: #FFE6CC;
    }
}

.submit,
.close{
    button {
        width: 100%;
        height: 45px;
        border: none;
        background: #BCBCBC;
        color: #fff;
        font-weight: 500;
        font-size: 14px;
        border-radius: 4px;
        margin-top: 10px;
        outline: none;
    }
    .btn-submit.active,
    button.btn-close{
        background: #ff8200;
    }
}

.rating-merchant {
    text-align: center;
    p.title{
        color: #1A1A1A;
        font-weight: 500;
        font-size: 16px;
    }
    .options{
        display: flex;
        justify-content: center;
    }
}

.rating-merchant__detail{
    .rating-merchant__detail-header{
        display: flex;

        background: #FFFFFF;
        border: 1px solid #F5F5F5;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 8px 10px;

        .title-header{ 
            width: 50%;
            line-height: 64px;
            color: #1A1A1A;
            font-weight: 500;

        }
        .option{
            float: right;
            text-align: center;
            height: 64px;
            width: 64px;
            img{
                width: 64px;
                height: 64px;
            }
            p{
                font-size: 12px;
                margin: 0;
            }
        }
    }
    .rating-merchant__detail-body{
        h3{
            margin: 15px 0;
            color: #1A1A1A;
            font-weight: 500;
        }

        .reasons {
            width: 100%;
            display: flex;
            flex-wrap: wrap;

            .reason {
                padding: 8px 16px;
                border: 1px solid #F2F2F2;
                background: #F2F2F2;
                margin: 0 8px 8px 0;
                color: #1a1a1a;
                border-radius: 20px;
                cursor: pointer;
                span{
                    font-size: 14px;
                }
            }
            .reason.active{
                border: 1px solid #ff8200;
                color: #ff8200;
                background: rgba(255, 130, 0, 0.1);
            }
        }

        .leave-feedback{
            display: flex;
            justify-content: center;
            cursor: pointer;
            margin-top: 10px;
            margin-bottom: 90px;
            span{
                color: #ff8200;
                font-weight: 600;
                font-size: 14px;
            }
        }

        .feedback-rating{
            margin-top: 10px;
            textarea {
                width: 100%;
                height: 92px;
                background-color: #f2f2f2;
                outline: none;  
                border: none;
                border-radius: 4px;
                resize: none;
                padding: 12px 0 12px 12px;
                font-size: 14px;
            }
            p{
                font-size: 14px;
                color: #7A8189;
            }
        }
 
    }   

}

.rating-merchant__success{
    text-align: center;
    img{
        background: #FFE6CC;
        border-radius: 50%;
    }
    p{
        margin: 16px 0;
        padding: 0 20px;
    }
}

@media only screen and (max-width: 768px) {
    .option {
        margin: 0 6px;
    }
}
@media only screen and (max-width: 414px) {
    .rating-merchant__detail {
        .rating-merchant__detail-body {
            .leave-feedback {
                margin-bottom: 70px;
            }
        } 
    }
}
</style>